import React, { useState, useEffect, useRef } from "react";
import { LoadScript, GoogleMap } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const defaultCenter = {
  lat: 28.6139,
  lng: 77.209,
};

const LoginPage = () => {
  const [currentPosition, setCurrentPosition] = useState(null);
  const [error, setError] = useState(null);
  const [isGeolocationAvailable, setIsGeolocationAvailable] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser");
      setIsGeolocationAvailable(false);
      setIsLoading(false);
      return;
    }

    const handlePositionUpdate = (position) => {
      const { latitude, longitude } = position.coords;
      const newPosition = { lat: latitude, lng: longitude };
      setCurrentPosition(newPosition);
      setIsLoading(false);

      // Update marker position if it exists
      if (markerRef.current) {
        markerRef.current.position = newPosition;
      }
    };

    const handleError = (error) => {
      setError(error.message);
      setIsLoading(false);
      console.error("Geolocation error:", error);
    };

    navigator.geolocation.getCurrentPosition(
      handlePositionUpdate,
      handleError,
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );

    const watchId = navigator.geolocation.watchPosition(
      handlePositionUpdate,
      handleError,
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );

    return () => {
      navigator.geolocation.clearWatch(watchId);
    };
  }, []);

  const handleMapLoad = async (map) => {
    mapRef.current = map;

    if (window.google && currentPosition) {
      // Load the Advanced Marker library
      const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

      // Create the advanced marker
      markerRef.current = new AdvancedMarkerElement({
        map: map,
        position: currentPosition,
        title: "You are here",
      });
    }
  };

  if (!isGeolocationAvailable) {
    return <div>Error: Geolocation is not supported by your browser.</div>;
  }

  if (error) {
    return (
      <div>Error: {error}. Please ensure location permissions are granted.</div>
    );
  }

  if (isLoading || !currentPosition) {
    return <div>Loading map...</div>;
  }

  return (
    <LoadScript googleMapsApiKey="AIzaSyD5H1Ko8GKpCEc_bS9yxJO_3sTxsAAz8JE">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={currentPosition}
        zoom={15}
        onLoad={handleMapLoad}
        options={{
          mapId: "462aec2e3c77d57ffddec3a9",  // ← Required for AdvancedMarkerElement
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      />
    </LoadScript>
  );
};

export default LoginPage;
